import { Component, EventEmitter, Input, Output } from '@angular/core';

import { BasicCitationStyle } from './basic-citation-style';
import { DEFAULT_CITATION_STYLES } from './default-citation-styles';

export type CitationChangeEvent = { style: BasicCitationStyle };

const NONE_STYLE_ID = '__NONE__';

/**
 * Component providing a menu of citation styles, including defaults like "none" or "current".
 */
@Component({
  selector: 'rl-citation-switcher-menu',
  templateUrl: './citation-switcher-menu.component.html',
})
export class CitationSwitcherMenuComponent {
  @Input() currentCitationStyle: BasicCitationStyle;
  @Input() tenantCitationStyles: BasicCitationStyle[];
  @Output()
  changeCitationStyle: EventEmitter<CitationChangeEvent> = new EventEmitter();

  noCitationStyle: BasicCitationStyle;
  isFilterLabelTruncated = false;

  constructor() {
    this.noCitationStyle = DEFAULT_CITATION_STYLES.NONE;
  }

  get defaultCitationStyle(): BasicCitationStyle {
    return this.tenantCitationStyles.find(style => style.is_default);
  }

  get nonDefaultCitationStyles(): BasicCitationStyle[] {
    return this.tenantCitationStyles.filter(style => !style.is_default);
  }

  getIdForStyle(style: BasicCitationStyle): string {
    return style.id || NONE_STYLE_ID;
  }

  /**
   * Emit an event for changing citation style.
   *
   * @param {BasicCitationStyle} style - the chosen style
   **/
  onChangeCitationStyle(style) {
    this.changeCitationStyle.emit({ style });
  }

  onFilterLabelTruncate(isTruncated: boolean) {
    this.isFilterLabelTruncated = isTruncated;
  }
}
